import * as actionTypes from '../actionsTypes'
import axios from '../../../http-config'
import swal from 'sweetalert'

export const fetchUserListingStart = () => {
    return({
        type      : actionTypes.FETCH_USER_LISTING_START,
        loading: false
    })
}

export const fetchUserListingSuccess = (response) => {
    return({
        type      : actionTypes.FETCH_USER_LISTING_SUCCESS,
        userData  : response.data.users,
        totalCount : response.totalCount,
        loading: true
    })
}

export const fetchUserListingFail = (err) => {
    return({
        type      : actionTypes.FETCH_USER_LISTING_FAIL,
        error     : err,
        loading: false
    })
}

export const fetchUserListing = (payload) => {
    return (dispatch) => {
        dispatch(fetchUserListingStart())
        axios({
            method    : 'get',
            url       : `user?userName=${payload.searchQuery}&sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}&roleId=${!!payload.roleFilter&&payload.roleFilter !=""? payload.roleFilter:''}`,
            headers   : {'Authorization': `Bearer ${payload.token}`}
        })
        .then((response) => {
            dispatch(fetchUserListingSuccess(response.data))
        })
        .catch((err) => {
            dispatch(fetchUserListingFail(err))
        })
    }
}

export const addUser = (payload,props, t) => {
    let token= payload.token
    return (dispatch) => {
        const url = '/user'
        dispatch(fetchUserListingStart())
        axios.post(url, payload, { headers : { "Authorization":`Bearer ${token}`}})
        .then((response) => {
            const fetchedResponse = response.data.success;
            fetchedResponse && swal({
                title: `${t("userAdd")}`,
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
            })
            dispatch(fetchUserListing({token: token,searchQuery:'',limit:10, page: 1, sortName:'', sortValue:''}))
            props.history.push('/user-management')
        }, 
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]}) 
            dispatch(fetchUserListing({token: token,searchQuery:'',limit:10, page: 1, sortName:'', sortValue:''}))
            props.history.push('/user-management')
        })
        .catch((err) => {
            dispatch(fetchUserListingFail(err))
        })
    }
}

export const editUser = (payload,props, t) => {
    let token= payload.token
    // const id = props.match.params.id
    return (dispatch) => {
        const payload1={
            id       : payload.id,
            userName : payload.userName,
            email    : payload.email,
            roleId   : payload.roleId,
            ulbId    : payload.ulbId,
            password : payload.password
            // isModuleAccess : payload.isModuleAccess
        }
        dispatch(fetchUserListingStart())
        const url = '/user'
        axios.put(url, payload1, {headers:{"Authorization":`Bearer ${token}`}})
        .then((response) => {
            const fetchedResponse = response.data.success;
            fetchedResponse && swal({
                title: `${t("ulbEdit")}`,
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
            })
            dispatch(fetchUserListing({token: token,searchQuery:'',limit:10, page: 1, sortName:'', sortValue:''}))
            props.history.push('/user-management')
        },
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]}) 
            dispatch(fetchUserListing({token: token,searchQuery:'',limit:10, page: 1, sortName:'', sortValue:''}))
            props.history.push('/user-management')
        })
        .catch((err) => {
            dispatch(fetchUserListingFail(err))
        })
    }
}

export const deleteUser = (payload, data, props, t) => {
    return (dispatch) => {
        dispatch(fetchUserListingStart())
        const url = '/user'
        axios.delete(url , { data : data, headers : {   "Authorization":`Bearer ${payload.token}`} })
        .then((response) => {
            dispatch(fetchUserListing(payload))
            swal({
                title: `${t("ulbDeleteErr5")}`,
                icon: "success",
            })
        }, 
        (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})
            dispatch(fetchUserListing({token: payload.token,searchQuery:'',limit:10, page: 1, sortName:'', sortValue:''}))
            props.history.push('/user-management')
        })
        .catch((err) => {
            dispatch(fetchUserListingFail(err))
        })
    }
}

export const searchUserName=(payload, t)=>{
    return dispatch =>{
        dispatch(fetchUserListingStart());
        const url = payload.searchByField==="user"? `user?userName=${payload.searchQuery}`: payload.searchByField==="role"? `user?roleName=${payload.searchQuery}`:`user?userName=${payload.searchQuery}`
        axios.get(url,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }} ).then(response=>{
            response && response.data && response.data.data.users &&
            response.data.data.users && 
            response.data.data.users.length == 0 && 
            swal(`${t("ulbRecordErr")}`, {
                icon: "warning",
              });
            dispatch(fetchUserListingSuccess(response.data));
        }).catch(err=>{
            dispatch(fetchUserListingFail(err));
        })
    }
}